import { StoreUsersState, User } from '@/types';

export default {
  users: (state: StoreUsersState): User[] => state.users,
};
